import { TimelineCalendarEvent } from "../calendar/fullCalendarTypes"

export type EventIndex = Record<string, TimelineCalendarEvent[]>

export function dropEventsFromIndex(index: EventIndex, eventIds: ReadonlySet<string>): void {
    if (!eventIds.size) return

    for (const resourceId of Object.keys(index)) {
        index[resourceId] = index[resourceId].filter((event) => !eventIds.has(event.id))
    }
}

export function mergeEventsIntoIndex(index: EventIndex, events: ReadonlyArray<TimelineCalendarEvent>): void {
    for (const event of events) {
        for (const resourceId of event.resourceIds) {
            const existing = (index[resourceId] ?? []).filter((indexed) => indexed.id !== event.id)
            index[resourceId] = [...existing, event]
        }
    }
}

/** Ids this source stopped returning — the index only merges, so cancellations need pruning. */
export function eventIdsToPrune(
    args: Readonly<{
        sourceKey: string
        currentEventIds: ReadonlySet<string>
        sourceEventIds: Readonly<Record<string, ReadonlySet<string>>>
    }>,
): ReadonlySet<string> {
    const { sourceKey, currentEventIds, sourceEventIds } = args

    const previousEventIds = sourceEventIds[sourceKey]
    if (!previousEventIds) return new Set()

    // a booking spanning midnight belongs to two day sources
    const claimedElsewhere = new Set(
        Object.entries(sourceEventIds)
            .filter(([key]) => key !== sourceKey)
            .flatMap(([, eventIds]) => Array.from(eventIds)),
    )

    return new Set(
        Array.from(previousEventIds).filter(
            (eventId) => !currentEventIds.has(eventId) && !claimedElsewhere.has(eventId),
        ),
    )
}
